import React, { FunctionComponent, useEffect, useState } from 'react';
import styles from './DonutChart.module.scss';
import Chart from 'react-apexcharts';
import { loadDonutChartData } from 'app/Requests';
import TimeIntervalFilter from 'app/components/TimeIntervalFilter/TimeIntervalFilter';
import Loader from 'app/components/Loader';
import NoData from 'app/components/NoData';
import { _t } from 'app/utils/i18n';
import CardTitle from 'app/components/CardTitle';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { path } from 'app/utils/path';
import { DonutChartData } from 'app/utils/types';
import { useParams } from 'react-router-dom';

import { nFormatter } from 'app/utils/numbersFormater';
import DotsMenu from 'app/components/DotsMenu';
import { useQuery } from 'react-query';
import {
  handleDataForSummary,
  handleFormatChartsData,
  handleTranslatedChartData,
} from 'app/utils/helpers';
import { CountDownLoader } from 'app/components/CountDownLoader/CountDownLoader';
import { Grid } from '@material-ui/core';
import ServerError from 'app/components/ErrorBoundary/ServerError';
import { useAppSettings } from 'app/context/settings/appSettings';
import { checkIsAuthorizedAction } from 'app/utils/check-is-authorized-action';
import { useModal } from 'app/context/Modal';

interface Props {
  slug?: string;
  limit?: number;
  title: string;
  data?: DonutChartData;
  showFilter?: boolean;
  unAnalyzed?: boolean;
  compId: string;
  donutTitle?: string;
  customFilters?: any;
  hideInput?: boolean;
  exportIcon?: boolean;
  dataFormatted?: boolean;
  dataWithTranslated?: boolean;
  sentmentError?: boolean;
  refetchCounter?: number;
  grid?: any;
  hideIfNoData?: boolean;
  additionalComponents?: JSX.Element;
  isReport?: boolean;
  testIsLoading?: boolean;
  withRefetch?: boolean;
  summarySentiment?: boolean;
  customTooltip?: boolean;
}

const DonutChart: FunctionComponent<Props> = ({
  slug,
  title,
  data,
  showFilter,
  limit,
  donutTitle,
  customFilters,
  compId,
  unAnalyzed,
  hideInput,
  exportIcon,
  dataFormatted,
  dataWithTranslated,
  sentmentError,
  refetchCounter,
  grid,
  hideIfNoData,
  additionalComponents,
  isReport,
  testIsLoading,
  withRefetch,
  summarySentiment,
  customTooltip,
}) => {
  const { theme } = useAppSettings();
  const routeParams = useParams<any>();
  const modal = useModal();
  const [filters, setFilters] = useState<null | { time_interval: string }>({
    ...customFilters,
    time_interval: 'ALL',
  });
  const [sentmentApiError, setSentmentApiError] = useState(false);
  const [preventLoading, setPreventLoading] = useState(true);

  const {
    isLoading,
    data: QData,
    isError,
    refetch,
  } = useQuery(
    [
      'loadDonutChartData',
      {
        slug,
        body: { ...filters, limit: limit ? limit : undefined },
        refetch: refetchCounter,
      },
    ],
    loadDonutChartData,
    {
      enabled: !!slug,
      refetchInterval: sentmentApiError ? 60000 : undefined,
      onError: () => setSentmentApiError(true),
      onSuccess: () => setSentmentApiError(false),
    },
  );

  const chartDataNotFormated = !!slug
    ? QData
    : data || { series: [], labels: [] };

  const chartData = dataFormatted
    ? handleFormatChartsData(chartDataNotFormated)
    : dataWithTranslated
      ? handleTranslatedChartData(chartDataNotFormated)
      : summarySentiment
        ? handleDataForSummary(QData)
        : chartDataNotFormated;

  const handleChangeFilters = (option: any): void => {
    setFilters({ ...filters, time_interval: option });
  };

  useEffect(() => {
    setTimeout(() => {
      setPreventLoading(false);
    }, 2200);
  }, []);
  useEffect(() => {
    if (withRefetch) {
      setFilters({ ...customFilters, time_interval: 'ALL' });
      refetch();
    }
  }, [customFilters]);
  if (
    !chartData ||
    !chartData?.series ||
    ((chartData?.series?.length === 0 ||
      // TODO  chartData?.values never used!!!
      chartData?.values?.length === 0 ||
      !chartDataNotFormated) &&
      hideIfNoData)
  )
    return <></>;
  const tooltipContent = (
    colors: string[],
    series: any,
    seriesIndex: any,
    dataPointIndex: any,
    w: any,
    subCategoryTooltip?: any,
    tooltip?: any,
  ) => {
    return `<div>fatma</div>`;

    //   return `<div class="arrow_box">
    //              <div>
    //                <h6>${columnHeader?.[0] ? columnHeader?.[0] : ''}</h6>
    //                <div>${names}</div>
    //              </div>
    //              <div>
    //                <h6>${columnHeader?.[1] ? columnHeader?.[1] : ''}</h6>
    //                <div>${mentions}</div>
    //              </div>
    //            </div>
    //      `;
    // }
  };
  return (
    <ServerError requiredApiCalls={sentmentError ? [] : [isError]}>
      <Grid item {...grid}>
        <div
          id={compId}
          className="position-relative"
          data-testid={`${compId}-testid`}
        >
          {donutTitle && (
            <CardTitle title={donutTitle} compId={compId} hideIcon={isReport} />
          )}
          {unAnalyzed ? (
            <>
              <div
                className={`${styles?.DonutChart} ${styles?.Sentiment}`}
                id={`${compId}-donutChart-sentiment`}
                data-testid={`${compId}-donutChart-sentiment`}
              >
                <div>
                  <p>
                    {_t('trends:You_Must')}
                    <br />
                    {_t('trends:Create_Hashtag_analysis')}
                    <br />
                    {_t('trends:To_see_Sentiments')}
                  </p>
                  <Link
                    to={
                      checkIsAuthorizedAction('HASHTAGS')
                        ? `${path.hashtags.EDIT_HASHTAG_URI}/${routeParams.id}`
                        : ''
                    }
                    onClick={() => {
                      !checkIsAuthorizedAction('HASHTAGS') &&
                        modal.show({
                          isAlternative: true,
                          message: _t('basic:you_are_not_authorize'),
                        });
                    }}
                  >
                    <Button className="main-btn">
                      {_t('trends:Create_Hashtag_Analysis')}
                    </Button>
                  </Link>
                </div>
                <div
                  className={styles?.TopBar}
                  id={`${compId}-donutChart-sentiment-topBar`}
                >
                  {showFilter && (
                    <TimeIntervalFilter
                      compId={compId}
                      hideInput={hideInput}
                      handleChangeTime={handleChangeFilters}
                      isReport={isReport}
                    />
                  )}
                  {exportIcon && (
                    <div className={styles?.dotsMenu}>
                      {!isReport && <DotsMenu id={compId} />}
                    </div>
                  )}
                </div>
                {!isLoading || !testIsLoading ? (
                  <Chart
                    options={getDonutOptions(
                      theme?.colors?.chartsColors,
                      chartData?.labels,
                      title,
                      customTooltip,
                      QData,
                    )}
                    series={chartData?.series}
                    type="donut"
                    height="200"
                    customTooltip={({
                      series,
                      seriesIndex,
                      dataPointIndex,
                      w,
                    }: any) => {
                      return tooltipContent(
                        theme.colors.chartsColors,
                        series,
                        seriesIndex,
                        dataPointIndex,
                        w,
                      );
                    }}
                  />
                ) : (
                  <Loader />
                )}
              </div>
            </>
          ) : sentmentError && isError ? (
            <>
              <div
                className={`${styles.DonutChart} ${styles.Sentiment}`}
                id={`${compId}-donutChart-sentiment`}
              >
                <div>
                  <p>
                    {_t('trends:Please_Wait_Until')}
                    <br />
                    {_t('trends:Hashtag_analysis_is_Finished')}
                    <br />
                    {_t('trends:To_see_Sentiments')}
                  </p>
                  <div>
                    <CountDownLoader
                      timeStartMilliseconds={60000}
                      isComplete={!isError}
                      moduleName={`${compId}-donutChart-sentiment`}
                    />
                  </div>
                </div>
                <div
                  className={styles?.TopBar}
                  id={`${compId}-donutChart-sentiment-topBar`}
                >
                  {showFilter && (
                    <TimeIntervalFilter
                      compId={compId}
                      hideInput={hideInput}
                      handleChangeTime={handleChangeFilters}
                      isReport={isReport}
                    />
                  )}
                  {exportIcon && (
                    <div className={styles?.dotsMenu}>
                      {!isReport && <DotsMenu id={compId} />}
                    </div>
                  )}
                </div>
                {!isLoading && !isError && !preventLoading ? (
                  <Chart
                    options={getDonutOptions(
                      theme?.colors?.chartsColors,
                      chartData?.labels,
                      title,
                      customTooltip,
                      QData,
                    )}
                    series={chartData?.series}
                    type="donut"
                    height="200"
                    customTooltip={({
                      series,
                      seriesIndex,
                      dataPointIndex,
                      w,
                    }: any) => {
                      return tooltipContent(
                        theme.colors.chartsColors,
                        series,
                        seriesIndex,
                        dataPointIndex,
                        w,
                      );
                    }}
                  />
                ) : (
                  <Loader />
                )}
              </div>
            </>
          ) : (
            <div
              className={styles?.DonutChart}
              id={`${compId}-donutChart-content`}
              data-testid={`${compId}-donutChart-content`}
            >
              <div
                className={styles?.TopBar}
                id={`${compId}-donutChart-topBar`}
              >
                {showFilter && (
                  <TimeIntervalFilter
                    allTimeInterval
                    compId={compId}
                    hideInput={hideInput}
                    handleChangeTime={handleChangeFilters}
                    isReport={isReport}
                  />
                )}
                {exportIcon && (
                  <div className={styles?.dotsMenu}>
                    {!isReport && <DotsMenu id={compId} />}
                  </div>
                )}
              </div>
              {!isLoading && !preventLoading ? (
                !(
                  chartData?.series?.length === 0 ||
                  // TODO values never used!!!
                  chartData?.values?.length === 0
                ) ? (
                  <Chart
                    options={getDonutOptions(
                      theme?.colors?.chartsColors,
                      chartData?.labels,
                      title,
                      customTooltip,
                      QData,
                    )}
                    series={chartData?.series}
                    type="donut"
                    height="200"
                    customTooltip={({
                      series,
                      seriesIndex,
                      dataPointIndex,
                      w,
                    }: any) => {
                      return tooltipContent(
                        theme.colors.chartsColors,
                        series,
                        seriesIndex,
                        dataPointIndex,
                        w,
                      );
                    }}
                  />
                ) : (
                  <NoData />
                )
              ) : (
                <Loader />
              )}
            </div>
          )}
          {additionalComponents}
        </div>
      </Grid>
    </ServerError>
  );
};

export default DonutChart;

function getDonutOptions(
  colors: string[],
  labels: string[],
  title: string,
  customTooltip: any,
  data: any,
): any {
  const optionsDonut = {
    chart: {
      id: 'donut-chart',
      // width: 150,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      colors: colors,
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
          offset: 0,
          minAngleToShowLabel: 10,
        },
        donut: {
          size: '65%',
          background: 'transparent',
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              label: title,
              fontSize: '12px',
              color: '#3f3737',
              formatter: function (w: any) {
                return nFormatter(
                  w?.globals?.seriesTotals?.reduce((a: number, b: number) => {
                    return a + b;
                  }, 0),
                );
              },
            },
          },
        },
      },
    },
    legend: {
      show: true,
      position: 'bottom',
      width: '50px',
      fontFamily: "'LatoRegular', sans-serif",
      fontSize: '10px',
      formatter: function (seriesName: string, opts: any) {
        const percentage =
          opts?.w?.globals?.seriesPercent[opts?.seriesIndex]?.[0]?.toFixed(1);
        const series_Name =
          seriesName?.length > 30
            ? `${seriesName?.slice(0, 30)}.....`
            : seriesName;
        return `${series_Name} (${isNaN(percentage) ? 0 : percentage}%)`;
      },
    },
    colors: colors,
    tooltip: {
      fillSeriesColor: false,
      custom: customTooltip
        ? function ({ series, seriesIndex }: any) {
            const dataSeries = Object.entries(data?.series[seriesIndex]).map(
              ([key, value]) => ({
                key,
                value,
              }),
            );

            return `<div id="test" style="padding: 5px; width:200px; background-color: var(--bgColor); border: 1px solid var(--borderColor);color:var(--mainColor);">
            <div style="display:flex ;justify-content:space-between;margin-bottom:10px;">

                   <div style="font-size:10px ;text-transform:uppercase">${_t('hashtags:total_posts')}</div>
                   <div>${series[seriesIndex]}</div> 
            </div>

            <div style="display:flex ;justify-content:space-between;font-size:8px ;text-transform:uppercase;margin-bottom:10px;">
                     
                   <div style="">${_t('hashtags:posts_type')}</div>
                   <div>${_t('hashtags:number')}</div> 
            </div>
            ${dataSeries?.map(
              (item: any) =>
                `<div style="display:flex ;justify-content:space-between;font-size:8px ;text-transform:uppercase;margin-bottom:10px;">
                <div>${item?.key}</div>
                <div>${nFormatter(item?.value)}</div>
              </div>`,
            ).join('\n')}
            </div>`;
          }
        : undefined,
    },
    labels: labels,
  };
  return optionsDonut;
}
